import { clsx } from 'clsx';
import type { ElementType } from 'react';
import { ReactNode } from 'react';
import { Box, PolymorphicComponentProps } from 'react-polymorphic-box';

import { TextVariants, text } from './text.css';

const defaultElement = 'span';

const getDefaultTag = (variants: TextVariants) => {
  switch (variants?.variant) {
    case 'page-title':
      return 'h1' as const;
    case 'section-title':
      return 'h2' as const;
    case 'paragraph':
      return 'p' as const;
    case 'meta':
      return 'p' as const;
    default:
      return defaultElement;
  }
};

type TextOwnProps = {
  children: ReactNode;
  tag?: ElementType;
  testid?: string;
} & TextVariants;

export type TextProps<E extends ElementType> = PolymorphicComponentProps<E, TextOwnProps>;

export const Text = <E extends ElementType = typeof defaultElement>({
  className,
  variant,
  align,
  testid,
  tag: Tag = getDefaultTag({ variant }),
  wordBreak,
  ...restProps
}: TextProps<E>) => (
  // @ts-expect-error
  <Box
    data-testid={testid}
    as={Tag}
    className={clsx(
      text({
        variant,
        align,
        wordBreak,
      }),
      className,
    )}
    {...restProps}
  />
);
